
<div color="info-secondary" valg-message-bar 
  *ngIf="isShown()">
  <span class="text--500">{{ 'infobox.simple_result_summary.prefix' | translate }} </span>
  <span>{{ 'infobox.simple_result_summary.text' | translate }} </span>
</div>